// extracted by mini-css-extract-plugin
export default {"JackpotBannerWrap":"Jackpot_JackpotBannerWrap__BNuas"};